export const REPORT_VERSION: Record<TopHap.ReportType, string> = {
  PROPERTY_FULL: '1.0',
  PROPERTY_ONE_PAGE: '1.0',
  CMA: '1.0'
}
